import React, {ComponentProps, FC, ReactElement} from 'react';

import {useFieldContext} from '@/components/AppForm/context';
import {FloatingWrapper} from '@/components/AppForm/primitives/FloatingWrapper';
import Input from '@/components/InputNBW/InputNBW';
import {twx} from '@/utils/tailwindUtils';

interface IInputProps extends ComponentProps<'input'> {
    containerClassName?: string;
    warningIcon?: ReactElement;
    clearButton?: ReactElement;
}

export const FieldInput: FC<IInputProps> = ({
    containerClassName,
    value,
    clearButton,
    warningIcon,
    children,
    ...rest
}) => {
    const {id, warningMessage, name} = useFieldContext();
    const isValid = !warningMessage;

    return (
        <div className={twx('relative w-full', containerClassName)}>
            {children}
            {/*@ts-ignore*/}
            <Input name={name} aria-invalid={!isValid} value={value} id={id} {...rest} />
            <FloatingWrapper>
                {value && isValid && clearButton}
                {!isValid && warningIcon}
            </FloatingWrapper>
        </div>
    );
};
